import { useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'
import { Menu, X } from 'lucide-react'
import type { SharedPageProps } from '@/types/shared'
import { HyrinWordmark } from '@/components/Shared/HyrinWordmark'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function CandidateNav() {
  const { currentPerson } = usePage<SharedPageProps>().props
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="relative flex h-16 items-center justify-between border-b border-border px-5 sm:px-9">
      <Link href="/" className="flex items-center gap-2">
        <HyrinWordmark />
      </Link>
      <div className="flex items-center gap-3 sm:gap-5">
        <nav className="hidden items-center gap-5 md:flex">
          <a
            href="/connect"
            className="font-sans text-[14px] text-muted-foreground transition-colors hover:text-foreground"
          >
            MCP
          </a>
          <Link
            href="/offers"
            className="font-sans text-[14px] text-muted-foreground transition-colors hover:text-foreground"
          >
            My offers
          </Link>
          {currentPerson && (
            <Link
              href={`/ind/${currentPerson.slug}`}
              className="font-sans text-[14px] text-muted-foreground transition-colors hover:text-foreground"
            >
              Profile
            </Link>
          )}
        </nav>
        {currentPerson && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                type="button"
                aria-label="Account menu"
                className="cursor-pointer rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                {currentPerson.avatarUrl ? (
                  <img
                    src={currentPerson.avatarUrl}
                    alt={currentPerson.name ?? 'Your avatar'}
                    className="size-[30px] rounded-full object-cover"
                  />
                ) : (
                  <div className="flex size-[30px] items-center justify-center rounded-full bg-primary font-sans text-[12px] font-bold text-primary-foreground">
                    {currentPerson.initials}
                  </div>
                )}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel className="font-sans text-[14px] text-foreground">
                {currentPerson.name && <div>{currentPerson.name}</div>}
                <div className="font-mono text-[12px] font-normal text-muted-foreground">
                  @{currentPerson.slug}
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="font-sans text-[14px]"
                onSelect={() => router.delete('/sign-out')}
              >
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          className="flex size-9 items-center justify-center rounded-[8px] border border-border text-foreground md:hidden"
        >
          {menuOpen ? <X className="size-[18px]" /> : <Menu className="size-[18px]" />}
        </button>
      </div>
      {menuOpen && (
        <nav className="absolute inset-x-0 top-16 z-20 flex flex-col border-b border-border bg-background px-5 py-3 md:hidden">
          <a
            href="/connect"
            className="py-3 font-sans text-[14px] text-muted-foreground"
            onClick={() => setMenuOpen(false)}
          >
            MCP
          </a>
          <Link
            href="/offers"
            className="py-3 font-sans text-[14px] text-muted-foreground"
            onClick={() => setMenuOpen(false)}
          >
            My offers
          </Link>
          {currentPerson && (
            <Link
              href={`/ind/${currentPerson.slug}`}
              className="py-3 font-sans text-[14px] text-muted-foreground"
              onClick={() => setMenuOpen(false)}
            >
              Profile
            </Link>
          )}
        </nav>
      )}
    </header>
  )
}
